
import React from 'react';
import { cn } from '@/lib/utils';
import { FeatureSectionData } from './types';

interface MobileFeatureTabsProps {
  sections: FeatureSectionData[];
  activeTab: string;
  onTabChange: (id: string) => void;
}

const MobileFeatureTabs: React.FC<MobileFeatureTabsProps> = ({
  sections,
  activeTab,
  onTabChange
}) => {
  return (
    <div className="bg-accent p-3 md:p-2 rounded-xl shadow-md">
      <div className="grid grid-cols-3 gap-2 md:gap-1.5">
        {sections.map((section) => (
          <button
            key={section.id}
            onClick={() => onTabChange(section.id)}
            className={cn(
              "flex flex-col items-center p-2.5 md:p-1.5 rounded-lg transition-all duration-300",
              activeTab === section.id 
                ? "bg-[#003a70] text-white shadow-md" 
                : "bg-white text-gray-600 hover:bg-gray-50"
            )}
          >
            <div className="mb-2 md:mb-1">
              {React.isValidElement(section.icon) ? 
                React.cloneElement(section.icon as React.ReactElement, {
                  size: 20,
                  className: activeTab === section.id ? "text-white" : "text-[#003a70]"
                }) : section.icon}
            </div>
            <span className="text-xs md:text-xs font-medium leading-none text-center px-0.5">{section.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileFeatureTabs;
